import { useMemo } from "react"
import styled from "styled-components"
import { FaCopy, FaEdit, FaHistory, FaPlay, FaPowerOff, FaTrash } from "react-icons/fa"
import Table from "../../sharedComponents/Table"
import useMe from "../../hooks/useMe"
import { formatSchedule } from "../Jobs/jobUtils"
import { IconButton, MutedText, StatusBadge } from "../Jobs/JobTable"

const TableWrapper = styled.div`
  height: calc(100vh - 250px);
  min-height: 420px;
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 100%;
  padding: 5px 0;
`

export default ({
  jobs,
  search,
  isLoading,
  onRun,
  onHistory,
  onEdit,
  onClone,
  onToggle,
  onDelete
}) => {
  const { hasEdit } = useMe()

  const cols = useMemo(() => ([
    {
      headerName: 'Job',
      field: 'name',
      tooltipField: 'name',
      minWidth: 250
    },
    {
      headerName: 'State',
      field: 'enabled',
      maxWidth: 110,
      cellRenderer: ({ data }) => (
        <StatusBadge $status={data.enabled ? 'success' : 'disabled'}>
          {data.enabled ? 'Enabled' : 'Disabled'}
        </StatusBadge>
      )
    },
    {
      headerName: 'Schedule',
      valueGetter: ({ data }) => formatSchedule(data),
      tooltipValueGetter: ({ data }) => data.scheduleExpression || formatSchedule(data),
      minWidth: 210
    },
    {
      headerName: 'Endpoint',
      field: 'endpointUrl',
      tooltipField: 'endpointUrl',
      minWidth: 260
    },
    {
      headerName: 'Timezone',
      field: 'scheduleExpressionTimezone',
      minWidth: 50
    },
    {
      headerName: 'Atlas Object',
      field: 'atlasName',
      minWidth: 190,
      cellRenderer: ({ data }) => data.atlasName
        ? <MutedText>{data.atlasName}</MutedText>
        : <MutedText></MutedText>
    },
    {
      headerName: 'Actions',
      minWidth: 235,
      cellRenderer: ({ data }) => (
        <Actions>
          {hasEdit &&
            <IconButton title='Run now' onClick={() => onRun(data)}>
              <FaPlay />
            </IconButton>
          }
          <IconButton title='History' onClick={() => onHistory(data)}>
            <FaHistory />
          </IconButton>
          {hasEdit &&
          <>
            <IconButton title='Edit' onClick={() => onEdit(data)}>
              <FaEdit />
            </IconButton>
            <IconButton title='Clone' onClick={() => onClone(data)}>
              <FaCopy />
            </IconButton>
            <IconButton title={data.enabled ? 'Disable' : 'Enable'} onClick={() => onToggle(data)}>
              <FaPowerOff />
            </IconButton>
            <IconButton title='Delete' onClick={() => onDelete(data)}>
              <FaTrash />
            </IconButton>
          </>
          }
        </Actions>
      )
    }
  ]), [onRun, onHistory, onEdit, onClone, onToggle, onDelete, hasEdit])

  return (
    <TableWrapper>
      <Table
        data={jobs}
        cols={cols}
        filter={search}
        isDisableAutoHeight={true}
        isLoading={isLoading}
      />
    </TableWrapper>
  )
}
